import Vue from 'vue';
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'; // Import Material Design Icons
import router from './router';
import AppSearchResult from './App';
import AttributeDisplay from '@/components/detail/AttributeDisplay';
import AttributesDisplay from '@/components/detail/AttributesDisplay';
import AttributeBlankNode from '@/components/detail/AttributeBlankNode';
import PropertyValue from '@/components/detail/PropertyValue';
import AxiomAnnotation from '@/components/detail/AxiomAnnotation';
import SmtAccordion from '@/components/detail/SmtAccordion';
import TooltipLabel from '@/components/detail/TooltipLabel';
import AttributeLanguageSelector from "@/components/AttributeLanguageSelector";
import LogicalAxiomeHasValue from "@/components/detail/LogicalAxiomeHasValue";
import LogicalAxiomeIntersectionOf from "@/components/detail/LogicalAxiomeIntersectionOf";
import LogicalAxiomeComplementOf from "@/components/detail/LogicalAxiomeComplementOf";
import LogicalAxiomeOneOf from "@/components/detail/LogicalAxiomeOneOf";
import LogicalAxiomeUnionOf from "@/components/detail/LogicalAxiomeUnionOf";
import LogicalAxiomeHasSelf from "@/components/detail/LogicalAxiomeHasSelf";
import LogicalAxiomeAllValuesFrom from "@/components/detail/LogicalAxiomeAllValuesFrom";
import LogicalAxiomeSomeValuesFrom from "@/components/detail/LogicalAxiomeSomeValuesFrom";
import LogicalAxiomeCardinality from "@/components/detail/LogicalAxiomeCardinality";
import LogicalAxiomeQualifiedCardinality from "@/components/detail/LogicalAxiomeQualifiedCardinality";
import LogicalAxiomeMaxCardinality from "@/components/detail/LogicalAxiomeMaxCardinality";
import LogicalAxiomeMinCardinality from "@/components/detail/LogicalAxiomeMinCardinality";
import LogicalAxiomeMaxQualifiedCardinality from "@/components/detail/LogicalAxiomeMaxQualifiedCardinality";
import LogicalAxiomeMinQualifiedCardinality from "@/components/detail/LogicalAxiomeMinQualifiedCardinality";

Vue.component('AttributeDisplay', AttributeDisplay);
Vue.component('AttributesDisplay', AttributesDisplay);
Vue.component('AttributeBlankNode', AttributeBlankNode);
Vue.component('AxiomAnnotation', AxiomAnnotation);
Vue.component('PropertyValue', PropertyValue);
Vue.component('SmtAccordion', SmtAccordion);
Vue.component('TooltipLabel', TooltipLabel);
Vue.component('AttributeLanguageSelector', AttributeLanguageSelector);
Vue.component('LogicalAxiomeHasValue', LogicalAxiomeHasValue);
Vue.component('LogicalAxiomeIntersectionOf', LogicalAxiomeIntersectionOf);
Vue.component('LogicalAxiomeComplementOf', LogicalAxiomeComplementOf);
Vue.component('LogicalAxiomeOneOf', LogicalAxiomeOneOf);
Vue.component('LogicalAxiomeUnionOf', LogicalAxiomeUnionOf);
Vue.component('LogicalAxiomeHasSelf', LogicalAxiomeHasSelf);
Vue.component('LogicalAxiomeAllValuesFrom', LogicalAxiomeAllValuesFrom);
Vue.component('LogicalAxiomeSomeValuesFrom', LogicalAxiomeSomeValuesFrom);
Vue.component('LogicalAxiomeCardinality', LogicalAxiomeCardinality);
Vue.component('LogicalAxiomeQualifiedCardinality', LogicalAxiomeQualifiedCardinality);
Vue.component('LogicalAxiomeMaxCardinality', LogicalAxiomeMaxCardinality);
Vue.component('LogicalAxiomeMinCardinality', LogicalAxiomeMinCardinality);
Vue.component('LogicalAxiomeMaxQualifiedCardinality', LogicalAxiomeMaxQualifiedCardinality);
Vue.component('LogicalAxiomeMinQualifiedCardinality', LogicalAxiomeMinQualifiedCardinality);

Vue.config.productionTip = false
// Vue.config.devtools = false
Vue.prototype.$searchResultManager = window.searchResultManager // Get common variables passed from WordPress

// Le script est chargé sur toutes les pages WordPress : on ne monte l'app
// que si la div cible est réellement présente sur la page.
const mountEl = document.getElementById('search-result-container')

const VueApp = mountEl && new Vue({
  router,
  vuetify,
  render: (h) => h(AppSearchResult)
}).$mount(mountEl)

export default VueApp;
